<ng-container *ngrxLet="oAuthLog$ as oAuthLog">
    <div class="log-cinematic-sub-section-o-auth__column-group">
        <!-- 1st column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.stateLabel | vtranslate }}
            </div>
            <div
                *ngIf="oAuthLog.state as state; else na"
                logFilter
                property="oauth_log.state"
                [value]="state"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ state }}
            </div>

            <div logFieldTitle>{{ l10nKeys.sessionCookieExpiredLabel | vtranslate }}</div>
            <div
                *ngIf="oAuthLog.is_session_cookie_expired !== undefined; else na"
                logFilter
                property="oauth_log.is_session_cookie_expired"
                [value]="oAuthLog.is_session_cookie_expired"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ oAuthLog.is_session_cookie_expired }}
            </div>
        </div>

        <!-- 2nd column -->
        <div logCinematicSectionColumn>
            <h5 class="log-cinematic-section__column-title">
                {{ globalL10nKeys.authorizationLabel | vtranslate }}
            </h5>
            <div logFieldTitle>
                {{ globalL10nKeys.ruleNameLabel | vtranslate }}
            </div>
            <div
                *ngIf="oAuthLog.authz_rule_match?.rule_name as ruleName; else na"
                logFilter
                property="oauth_log.authz_rule_match.rule_name"
                [value]="ruleName"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ ruleName }}
            </div>

            <div logFieldTitle>{{ globalL10nKeys.actionLabel | vtranslate }}</div>
            <div
                *ngIf="oAuthLog.authz_rule_match?.rule_action as action; else na"
                logFilter
                property="oauth_log.authz_rule_match.rule_action"
                [value]="action"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ action }}
            </div>
        </div>

        <!-- 3rd column -->
        <div logCinematicSectionColumn>
            <h5 class="log-cinematic-section__column-title">
                {{ globalL10nKeys.authenticationLabel | vtranslate }}
            </h5>
            <div logFieldTitle>
                {{ globalL10nKeys.ruleNameLabel | vtranslate }}
            </div>
            <div
                *ngIf="oAuthLog.authn_rule_match?.rule_name as ruleName; else na"
                logFilter
                property="oauth_log.authn_rule_match.rule_name"
                [value]="ruleName"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ ruleName }}
            </div>

            <div logFieldTitle>{{ globalL10nKeys.actionLabel | vtranslate }}</div>
            <div
                *ngIf="oAuthLog.authn_rule_match?.rule_action as action; else na"
                logFilter
                property="oauth_log.authn_rule_match.rule_action"
                [value]="action"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ action }}
            </div>
        </div>
    </div>

    <!-- Expandable sub-request logs -->
    <ng-container *ngFor="let oAuthSubRequestField of oAuthSubRequestFields; trackBy: trackByIndex">
        <expander
            *ngIf="oAuthLog[oAuthSubRequestField.fieldName] as oAuthSubRequestLog"
            openerClassName="log-cinematic-sub-section-o-auth__expander-opener"
        >
            <opener class="log-cinematic-sub-section-o-auth__expander-opener-text">
                {{ oAuthSubRequestField.fieldLabel }}
            </opener>
            <content class="log-cinematic-sub-section-o-auth__expander-content">
                <!-- a workaround of setting "fieldName" for the contained scope -->
                <ng-container *ngIf="oAuthSubRequestField.fieldName as fieldName">
                    <!-- Summary section -->
                    <div class="log-cinematic-sub-section-o-auth__expander-content-section log-cinematic-sub-section-o-auth__column-group">
                        <!-- left column -->
                        <div logCinematicSectionColumn>
                            <h5 class="log-cinematic-section__column-title">
                                {{ globalL10nKeys.summaryLabel | vtranslate }}
                            </h5>

                            <ng-container *ngIf="oAuthSubRequestLog.sub_request_log as subRequestLog">
                                <div logFieldTitle>{{ globalL10nKeys.poolLabel | vtranslate }}</div>
                                <div
                                    *ngIf="subRequestLog.pool_name as poolName; else na"
                                    logFilter
                                    [property]="subRequestLogFilterPropertyHash[fieldName]['pool_name']"
                                    [value]="poolName"
                                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                                >
                                    {{ poolName }}
                                </div>

                                <div logFieldTitle>{{ globalL10nKeys.sourcePortLabel | vtranslate }}</div>
                                <div
                                    *ngIf="subRequestLog.source_port !== undefined; else na"
                                    logFilter
                                    [property]="subRequestLogFilterPropertyHash[fieldName]['source_port']"
                                    [value]="subRequestLog.source_port"
                                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                                >
                                    {{ subRequestLog.source_port }}
                                </div>

                                <div logFieldTitle>{{ globalL10nKeys.totalTimeLabel | vtranslate }}</div>
                                <ng-container *ngIf="subRequestLog.total_time !== undefined; else na">
                                    <span
                                        logFilterList
                                        [property]="subRequestLogFilterPropertyHash[fieldName]['total_time']"
                                        [value]="subRequestLog.total_time"
                                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                                    >
                                        {{ subRequestLog.total_time }}
                                    </span>
                                    {{ globalL10nKeys.msLabel | vtranslate }}
                                </ng-container>

                                <div logFieldTitle>{{ l10nKeys.errorCodeLabel | vtranslate }}</div>
                                <div
                                    *ngIf="oAuthSubRequestLog.error_code !== undefined; else na"
                                    logFilter
                                    [property]="subRequestLogFilterPropertyHash[fieldName]['error_code']"
                                    [value]="subRequestLog.error_code"
                                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                                >
                                    {{ oAuthSubRequestLog.error_code }}
                                </div>
                            </ng-container>
                        </div>

                        <!-- right column -->
                        <div
                            logCinematicSectionColumn
                            [withDivider]="false"
                            *ngIf="oAuthSubRequestLog.sub_request_log as subRequestLog"
                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                        >
                            <div
                                logFieldTitle
                                [withMarginTop]="false"
                            >
                                {{ globalL10nKeys.descriptionLabel | vtranslate }}
                            </div>
                            {{ schemaService.getFieldDescription('OauthLog', fieldName) }}

                            <div logFieldTitle>{{ globalL10nKeys.serverNameLabel | vtranslate }}</div>
                            <div
                                *ngIf="subRequestLog.server_name as serverName; else na"
                                logFilter
                                [property]="subRequestLogFilterPropertyHash[fieldName]['server_name']"
                                [value]="serverName"
                                (onFilterAdd)="logCinematicStore.closeCinematic()"
                            >
                                {{ serverName }}
                            </div>

                            <div logFieldTitle>
                                {{ globalL10nKeys.serverIpLabel | vtranslate }}:{{ globalL10nKeys.portLabel | vtranslate }}
                            </div>
                            <log-cinematic-ip-field
                                *ngIf="subRequestLog.server_ip !== undefined; else na"
                                [property]="subRequestLogFilterPropertyHash[fieldName]['server_ip']"
                                [ip]="subRequestLog.server_ip"
                                [portProperty]="subRequestLogFilterPropertyHash[fieldName]['server_port']"
                                [port]="subRequestLog.server_port"
                            ></log-cinematic-ip-field>

                            <h5 class="log-cinematic-section__column-title">
                                {{ globalL10nKeys.responseLabel | vtranslate }}
                            </h5>

                            <div logFieldTitle>{{ globalL10nKeys.responseCodeLabel | vtranslate }}</div>
                            <div
                                *ngIf="subRequestLog.http_response_code !== undefined; else na"
                                logFilter
                                [property]="subRequestLogFilterPropertyHash[fieldName]['http_response_code']"
                                [value]="subRequestLog.http_response_code"
                                (onFilterAdd)="logCinematicStore.closeCinematic()"
                            >
                                {{ subRequestLog.http_response_code }}
                            </div>
                        </div>
                    </div>

                    <!-- Headers section -->
                    <div
                        class="log-cinematic-sub-section-o-auth__expander-content-section"
                        *ngIf="oAuthSubRequestLog.sub_request_log as subRequestLog"
                    >
                        <div logCinematicSectionColumn>
                            <h5 class="log-cinematic-section__column-title">
                                {{ l10nKeys.oAuthHeadersLabel | vtranslate }}
                            </h5>
                            <avi-diff-grid
                                [config]="headersDiffGridConfig"
                                [rows]="subRequestLog | subLogHeadersDiffSourcePair : 'headers_sent_to_server' : 'headers_received_from_server' | aviDiffGridRows"
                            ></avi-diff-grid>
                        </div>
                    </div>
                </ng-container>
            </content>
        </expander>
    </ng-container>
</ng-container>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>
